const BoardOfDirectorsData = [
  {
    id: 1,
    src: "https://ik.imagekit.io/wwg4nuz3a/bod/ron-cropped-1.jpg?updatedAt=1782050783781?",
    name: "Atty. Alberto Ronaldo Salamillas Jr.",
    text: "President",
  },
  {
    id: 2,
    src: "https://ik.imagekit.io/wwg4nuz3a/bod/pert-cropped.jpg?",
    name: "Christopher Anthony Lagman",
    text: "Immediate Past President",
  },
  {
    id: 3,
    src: "https://ik.imagekit.io/wwg4nuz3a/bod/patrisha-cropped.jpg?",
    name: "Patricia Jill Lagman",
    text: "Executive Vice President",
  },
  {
    id: 4,
    src: "https://ik.imagekit.io/wwg4nuz3a/bod/maru-cropped.jpg?",
    name: "Ar. Immaruel Quinto",
    text: "Vice President - Internal",
  },
  {
    id: 5,
    src: "https://ik.imagekit.io/wwg4nuz3a/bod/giselle-cropped.jpg?",
    name: "Giselle Hernandez",
    text: "Vice President - External",
  },
  {
    id: 6,
    src: "https://ik.imagekit.io/wwg4nuz3a/bod/aljohn-cropped.jpg?",
    name: "Dr. Aljohn Malaluan",
    text: "Secretary",
  },
  {
    id: 7,
    src: "https://ik.imagekit.io/wwg4nuz3a/bod/mark-cropped.jpg?",
    name: "Mark Anthony Yasay",
    text: "Deputy Secretary",
  },
  {
    id: 8,
    src: "https://ik.imagekit.io/wwg4nuz3a/bod/carina-cropped.jpg?",
    name: "Maria Carina Lagonsin",
    text: "Treasurer",
  },
  {
    id: 9,
    src: "https://ik.imagekit.io/wwg4nuz3a/bod/angel-cropped.jpg?",
    name: "Dr. Angelie Rebleza",
    text: "Auditor",
  },
  {
    id: 10,
    src: "https://ik.imagekit.io/wwg4nuz3a/bod/zekk-cropped.jpg?",
    name: "Franc Johnric Bartolome",
    text: "Director For Connect",
  },
  {
    id: 11,
    src: "https://ik.imagekit.io/wwg4nuz3a/bod/tasha-cropped.jpg?",
    name: "Tasha Marie Mendoza",
    text: "Director for Impact",
  },
  {
    id: 12,
    src: "https://ik.imagekit.io/wwg4nuz3a/bod/gelo-cropped.jpg?",
    name: "John Angelo Pasumbal",
    text: "Director for Collaboration",
  },
  {
    id: 13,
    src: "https://ik.imagekit.io/wwg4nuz3a/bod/felix-cropped.jpg?",
    name: "Atty. Felix Crisanto Ingente",
    text: "Director For Local Skills Development",
  },
  {
    id: 14,
    src: "https://ik.imagekit.io/wwg4nuz3a/bod/rupert-cropped.jpg?",
    name: "John Rupert Martin",
    text: "Director For Invest",
  }
]

export default BoardOfDirectorsData;